export const BASE_URL = 'https://mobilfutarapi.tmx.hu';
export const TMX_URL = 'https://www.tmx.hu/';
export const CRM_URL = 'https://mobilfutar.tmx.hu/';
export const LION_URL = 'https://lionapi.tmx.hu';
